import {Component, Inject, OnInit} from 'ng-metadata/core';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import {LoginService} from "../login/login.service";
import {MediaQueries} from "../../infra/mediaQueries.service";
import {SearchService} from "../../search/search.service";
import {SharedSessionStorage} from "../../infra/sharedSessionStorage.service";
import {PrimoExploreService} from "../../primoExplore/primoExplore.service";
import {TimeoutToastService} from "./timeoutToast.service";
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {getChosenKeepMeSignInConf, getKeepMeSignInConfig} from '../../appConfig/appConfigForward';
import {MappingTablesCache} from "../../mappingTablesCache/mappingTablesCache.service";
import {StorageUtil} from '../../infra/storageUtil.service';
import {AnalyticsUtils} from "../../nddUtils/analyticsUtils.service";

@Component({
    selector: 'prm-timeout-toast',
    templateUrl: 'components/security/timeoutToast/timeout-toast.html',
})

export class PrmTimeoutToast implements OnInit{
    private _currentState: string;
    private DISPLAY_USER_SETTINGS: string = 'display_user_settings';
    private LOGGED_OFF_AFTER_EXTENDED_SESSION: string = 'loggedOffAfterExtendedSession';

    constructor(private primolyticsService: PrimolyticsService,
                @Inject('$mdToast') private $mdToast: ng.material.IToastService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('favoritesIcons') public favoritesIcons,
                private loginService: LoginService,
                private mediaQueries: MediaQueries,
                private searchService: SearchService,
                private sharedSessionStorage: SharedSessionStorage,
                private primoExploreService: PrimoExploreService,
                private timeoutToastService: TimeoutToastService,
                private configurationUtil: ConfigurationUtil,
                private mappingTablesCache: MappingTablesCache,
                private storageUtil: StorageUtil,
                private analyticsUtils: AnalyticsUtils
                ) {
    }

    ngOnInit() {
        this.currentState = this.$location.path();
    }

    private onDismiss() {
        this.$mdToast.hide();
        //The Following code fixes a bug with mdToast who places "position: relative" on root element but doesn't remove it once it is closed.
        //This causes md-dialog to not display correctly.
        this.$timeout(() => {
            let elem = document.querySelector("primo-explore");
            if (elem) {
                angular.element(elem).css('position', '');
            }
        }, 0);
    }

    public detectMobile(){
        if( this.mediaQueries.xs || this.mediaQueries.sm){
            return true;
        }
        return false;
    }

    @beacon({'p':'general', 'op':'signIn'})
    handleLogin() {
        this.$mdToast.hide();
        //The Following code fixes a bug with mdToast who places "position: relative" on root element but doesn't remove it once it is closed.
        //This causes md-dialog to not display correctly.
        this.$timeout(() => {
            let elem = document.querySelector("primo-explore");
            if (elem) {
                angular.element(elem).css('position', '');
            }
        }, 0);

        this.$timeout(()=>{
            this.loginService.handleLoginClick();
        }, 200);

        this.loginService.sendAnalytics('manually');
    }

    public isSearchDone() {
        return this.searchService.isSearchDone();
    }

    public showToastMessage() {
        return !this.isStateChange() && this.timeoutToastService.showTimeOutToastMessage;
    }

    get currentState() {
        return this._currentState;
    }

    set currentState(value) {
        this._currentState = value;
    }

    private isStateChange(){
        if (this.currentState !== this.$location.path()){
            return true;
        }
        return false;
    }

    public isKeepMeSignInEnabled() {
        let chosenConf = getChosenKeepMeSignInConf();

        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            let keepMeSignInFeatureFlag = this.configurationUtil.getFeatureFlag('enable_patrons_to_check_keep_me_signed_in');
            return chosenConf != null && keepMeSignInFeatureFlag;
        }

        return chosenConf != null;
    }

    private showUserSetting() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.INSTITUTION_PROPERTIES, { target: 'true', source1: this.DISPLAY_USER_SETTINGS }).length > 0;
    }

    private showAutoExtendMySessionToggle() {
        return getKeepMeSignInConfig().isEnableUserSettingForExtendSession;
    }

    public isAutoExtendMySessionEnable() {
        return this.showUserSetting ? this.showAutoExtendMySessionToggle(): false;
    }

    public isAutoExtendMySessionEnabledByUser(){
        let isAutoExtendMySessionEnabledByUser = this.storageUtil.sessionStorage.getItem(this.LOGGED_OFF_AFTER_EXTENDED_SESSION) === 'true';
        return isAutoExtendMySessionEnabledByUser;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/timeoutToast/timeoutToast.directive.ts